import { render, staticRenderFns } from "./GoodsItem2.vue?vue&type=template&id=0d3e7eee&scoped=true&"
import script from "./GoodsItem2.vue?vue&type=script&lang=js&"
export * from "./GoodsItem2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsItem2.vue?vue&type=style&index=0&id=0d3e7eee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e7eee",
  null
  
)

export default component.exports